// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import Group from "../Images/Group.png";
// import Worktogether from "../Images/Work Together Image.png";
// import Frame1 from "../Images/Frame1.png";
// import Frame2 from "../Images/Frame2.png";
// import Frame3 from "../Images/Frame3.png";
// import LandingNavbar from "../features/navbar/LandingNavbar";
// import Individual from "../Images/Individual.png";
// import Advocate from "../Images/Advocate.png";
// import Legal from "../Images/Legal.png";
// import { useDispatch } from "react-redux";
// import { clearOTPs } from "../features/modal/modalSlices/MobileEmailModalSlice";
// import Footer from "./Footer";
// import NewRegisterModal from "../features/modal/NewRegisterModal";

// function LandingPage() {
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const dispatch = useDispatch();

//   const handleClick = () => {
//     dispatch(clearOTPs());
//   };

//   return (
//     <>
//       <LandingNavbar />

//       <div className="bg-blue-100">
//         <div className="container mx-auto py-8 px-4 md:w-4/6">
//           <div className="flex flex-col md:flex-row items-center justify-between">
//             <div className="md:w-4/5 text-center md:text-left">
//               <h4 className="text-sky-600 text-2xl font-bold mb-4 mt-8">
//                 Uttrakhand Online Public Data Entry Service !
//               </h4>
//               <p className="text-lg font-semibold mb-4">
//                 Click, Register, Relax: Your Property Journey Starts Here
//               </p>
//               <p className="text-sm mb-6">
//                 With e-registration initiative department is offering
//                 citizen-friendly, hassle-free & transparent services to
//                 stakeholders and web-based application offers services to
//                 register property transactions through online Public Data Entry
//                 (PDE) under Registration Act, 1908.
//               </p>
//               <Link
//                 to="/Login"
//                 className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-10 rounded-full text-lg"
//                 onClick={handleClick}
//               >
//                 Login
//               </Link>
//             </div>

//             <div className="md:w-1/5 mt-8 md:mt-0 md:ml-8 text-center">
//               <img
//                 src={Group}
//                 alt="Group"
//                 className="w-full h-auto max-w-xs mx-auto"
//               />
//             </div>
//           </div>

//           <div className="relative mt-12 mx-2 md:mx-10">
//             {/* Main container with blue background, shadow, and rounded corners */}
//             <div className="relative flex flex-col md:flex-row justify-center items-center mt-12 p-2 md:mx-10 bg-blue-100 shadow-lg rounded-3xl">
//               {/* Pseudo-element for white border */}
//               {/* <div className="absolute top-0 left-0 right-0 h-1/12 bg-slate-100 rounded-t-full"></div> */}
//               <div className="absolute top-0 left-0 right-0 h-1/8 bg-white rounded-t-full transform translate-y-1/2"></div>
//               <div className="flex items-center mb-8 md:mb-0">
//                 <img
//                   src={Frame1}
//                   alt="Office Icon"
//                   className="w-7 h-7 mb-2 md:mr-4"
//                 />
//                 <div className="md:text-left">
//                   <div className="text-2xl text-amber-500 font-bold mt-2">
//                     90
//                   </div>
//                   <div className="text-sm">Sub-Registrar Offices</div>
//                 </div>
//               </div>
//               <div className="flex items-center mb-8 md:mb-0 md:ml-4">
//                 <img
//                   src={Frame2}
//                   alt="Registry Icon"
//                   className="w-7 h-7 mb-2 md:mr-4"
//                 />
//                 <div className="md:text-left">
//                   <div className="text-2xl text-amber-500 font-bold mt-2">
//                     2248
//                   </div>
//                   <div className="text-sm ">Registry approx per day</div>
//                 </div>
//               </div>
//               <div className="flex items-center mb-8 md:mb-0 md:ml-4">
//                 <img
//                   src={Frame3}
//                   alt="Revenue Icon"
//                   className="w-7 h-7 mb-2 md:mr-4"
//                 />
//                 <div className="md:text-left">
//                   <div className="text-2xl text-amber-500 font-bold mt-2">
//                     4 Cr
//                   </div>
//                   <div className="text-sm">Revenue/day</div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="container mx-auto py-8 px-4 md:w-4/6">
//         <div className="flex flex-col md:flex-row items-center justify-between md:mx-8">
//           <div className="md:w-1/5  md:mt-8 md:ml-8 text-center">
//             <img
//               src={Worktogether}
//               alt="Work Together"
//               className="w-full h-auto"
//             />
//           </div>
//           <div className="md:w-4/5 text-center md:text-left  md:ml-8 mb-4 md:mt-10">
//             <h4 className="text-black text-2xl font-bold ">
//               Register Your Property in Uttarakhand
//             </h4>
//             <p className="text-sm font-semibold mb-4 mt-4">
//               With e-registration initiative department is offering
//               citizen-friendly, hassle-free & transparent services to
//               stakeholders and web-based application offers services to register
//               property transactions through online Public Data Entry (PDE) under
//               Registration Act, 1908.
//             </p>
//             <button
//               onClick={() => setIsModalOpen(true)}
//               className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-10 rounded-full text-lg mt-4"
//             >
//               Try it Now
//             </button>
//           </div>
//         </div>
//       </div>
//       <Footer />

//       {/* ===== Modal Overlay ===== */}
//       {isModalOpen && (
//         <NewRegisterModal
//           isOpen={isModalOpen}
//           onClose={() => setIsModalOpen(false)}
//         />
//       )}
//     </>
//   );
// }

// export default LandingPage;

import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import LandingNavbar from "../features/navbar/LandingNavbar";
import Footer from "./Footer";
import NewRegisterModal from "../features/modal/NewRegisterModal";
import { clearOTPs } from "../features/modal/modalSlices/MobileEmailModalSlice";

// Image imports (adjust paths as needed)
import Group from "../Images/Group.png";
import Worktogether from "../Images/Work Together Image.png";
import Frame1 from "../Images/Frame1.png";
import Frame2 from "../Images/Frame2.png";
import Frame3 from "../Images/Frame3.png";

function LandingPage() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();

  // Clears any stored OTP values when the user clicks “Login”
  const handleClick = () => {
    dispatch(clearOTPs());
  };

  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-1">
        <LandingNavbar />

        <div className="bg-blue-100">
          <div className="container mx-auto py-8 px-4 md:w-4/6">
            <div className="flex flex-col md:flex-row items-center justify-between">
              <div className="md:w-4/5 text-center md:text-left">
                <h4 className="text-sky-600 text-2xl font-bold mb-4 mt-8">
                  Uttarakhand Online Public Data Entry Service!
                </h4>
                <p className="text-lg font-semibold mb-4">
                  Click, Register, Relax: Your Property Journey Starts Here
                </p>
                <p className="text-sm mb-6">
                  With the e-registration initiative, the department is offering
                  citizen-friendly, hassle-free & transparent services to
                  stakeholders. This web-based application allows you to
                  register property transactions through online Public Data
                  Entry (PDE) under the Registration Act, 1908.
                </p>
                <Link
                  to="/Login"
                  className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-10 rounded-full text-lg"
                  onClick={handleClick}
                >
                  Login
                </Link>
              </div>

              <div className="md:w-1/5 mt-8 md:mt-0 md:ml-8 text-center">
                <img
                  src={Group}
                  alt="Group"
                  className="w-full h-auto max-w-xs mx-auto"
                />
              </div>
            </div>

            <div className="relative mt-12 mx-2 md:mx-10">
              <div className="relative flex flex-col md:flex-row justify-center items-center mt-12 p-2 md:mx-10 bg-blue-100 shadow-lg rounded-3xl">
                <div className="absolute top-0 left-0 right-0 h-1/8 bg-white rounded-t-full transform translate-y-1/2"></div>

                {/* Stat #1 */}
                <div className="flex items-center mb-8 md:mb-0">
                  <img
                    src={Frame1}
                    alt="Office Icon"
                    className="w-7 h-7 mb-2 md:mr-4"
                  />
                  <div className="md:text-left">
                    <div className="text-2xl text-amber-500 font-bold mt-2">
                      90
                    </div>
                    <div className="text-sm">Sub-Registrar Offices</div>
                  </div>
                </div>

                <div className="flex items-center mb-8 md:mb-0 md:ml-4">
                  <img
                    src={Frame2}
                    alt="Registry Icon"
                    className="w-7 h-7 mb-2 md:mr-4"
                  />
                  <div className="md:text-left">
                    <div className="text-2xl text-amber-500 font-bold mt-2">
                      2248
                    </div>
                    <div className="text-sm">Registry approx per day</div>
                  </div>
                </div>

                <div className="flex items-center mb-8 md:mb-0 md:ml-4">
                  <img
                    src={Frame3}
                    alt="Revenue Icon"
                    className="w-7 h-7 mb-2 md:mr-4"
                  />
                  <div className="md:text-left">
                    <div className="text-2xl text-amber-500 font-bold mt-2">
                      4 Cr
                    </div>
                    <div className="text-sm">Revenue/day</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container mx-auto py-8 px-4 md:w-4/6">
          <div className="flex flex-col md:flex-row items-center justify-between md:mx-8">
            <div className="md:w-1/5 md:mt-8 md:ml-8 text-center">
              <img
                src={Worktogether}
                alt="Work Together"
                className="w-full h-auto"
              />
            </div>

            <div className="md:w-4/5 text-center md:text-left md:ml-8 mb-4 md:mt-10">
              <h4 className="text-black text-2xl font-bold">
                Register Your Property in Uttarakhand
              </h4>
              <p className="text-sm font-semibold mb-4 mt-4">
                With the e-registration initiative, the department is offering
                citizen-friendly, hassle-free & transparent services to
                stakeholders. This web-based application allows you to register
                property transactions through online Public Data Entry (PDE)
                under the Registration Act, 1908.
              </p>
              <button
                onClick={() => setIsModalOpen(true)}
                className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-10 rounded-full text-lg mt-4"
              >
                Try it Now
              </button>
            </div>
          </div>
        </div>
      </main>
      <Footer />

      {/* Modal overlay (conditionally rendered) */}
      {isModalOpen && (
        <NewRegisterModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </div>
  );
}

export default LandingPage;
